/**
 * What the signed-in account can do.
 *
 * The UI gates on capability rather than on a role name, so the boundary
 * moves with the permission model instead of being hardcoded in two places.
 */

export const PERMISSIONS = {
  MANAGE_USERS: 'manage_users',
  MANAGE_ROLES: 'manage_roles_permissions',
  START_OBSERVATION: 'start_observation',
  DEBRIEF_FEEDBACK: 'debrief_feedback',
};

export const can = (user, code) =>
  Array.isArray(user?.permissions) && user.permissions.includes(code);

/** Administration covers accounts, roles, schools and patches. */
export const canAdminister = (user) => can(user, PERMISSIONS.MANAGE_USERS);

/**
 * An administrator manages the system but does not observe in it, so the
 * observation entry points are hidden rather than shown and then refused.
 */
export const canObserve = (user) => can(user, PERMISSIONS.START_OBSERVATION);

/** Running a debrief and sending feedback is its own permission. */
export const canDebrief = (user) => can(user, PERMISSIONS.DEBRIEF_FEEDBACK);
